import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import useConfig from 'hooks/useConfig';
import { isApp } from 'utils/app';
import { env } from 'constants';

const VERSION = require('../../package.json').version;

function MetaTags() {
  const config = useConfig();

  const metaTagsEntries = useMemo(() => {
    if (!config.web) {
      return [];
    }
    const metaEntries = Object.entries(config.web?.pageMeta);
    return metaEntries.map(([key, value]) => <meta name={key} content={value} key={key} />);
  }, [config?.web?.pageMeta]);

  if (!config.web) {
    return;
  }
  let viewportContent = 'width=device-width, initial-scale=1, user-scalable=0';
  if (isApp()) {
    viewportContent = `${viewportContent}, shrink-to-fit=no, viewport-fit=cover`;
  }
  const favicon = config.pwa?.assets?.favicon ||
  config.pwa?.assets?.icon ||
  config.pwa?.assets?.logo ||
  config.web?.favicon || // deprecated
    config.web?.logo ||
    '/logo.png';

  return (
    <Helmet>
      <meta name="viewport" content={viewportContent} />
      {/* doesn't work properly and doesn't get overridden by MDP */}
      {!env.IS_CATERING && <title>{config.web.pageTitle}</title>}
      <link rel="icon" href={favicon} />
      <link rel="apple-touch-icon" href={favicon} />
      {metaTagsEntries}
      <meta name="version" content={VERSION} />
    </Helmet>
  );
}

export default MetaTags;
